export default {
  setOnlineStatus: (state, payload) => {
    state.onlineStatus = payload
  },
  setCurrentCoordinates: (state, coordinates) => {
    const newCoordinates = {
      latitude: coordinates?.latitude || state.currentCoordinates.latitude,
      longitude: coordinates.longitude || state.currentCoordinates.longitude,
      accuracy: coordinates.accuracy || state.currentCoordinates.accuracy
    }
    state.currentCoordinates = newCoordinates
  }
}
